import React, { useState, useEffect } from 'react';
import {
  Row, Col, Spin, notification,
} from 'antd';
import {
  useNavigate, useLocation,
} from 'react-router-dom';
import MontagemEquipamentoDetails from '../details/Details';
import MontagemEquipamentoSummary from '../summary/Summary';
import SuccessSolicitation from '../../../serviceComponents/successSolicitation/SuccessSolicitation';
import { getUserType } from '../../../../../utils/users';

const MontagemEquipamentoFlow = () => {
  const initialParameters = () => ({
    isSkippingSteps: false,
    serviceList: [],

    selectedService: {
      id: 0,
      idCode: '',
      name: '',
      description: '',
      types: [],
    },

    selectedType: {
      id: 0,
      idCode: '',
      name: '',
      subtypes: [],
    },

    selectedProperty: {
      id: '',
      name: '',

      location: {
        lat: null,
        lon: null,
      },

      registeredOn: '',
      matriculation: '',
    },

    selectedMatriculation: getUserType() === 'COOPERCITRUS' ? null : 'COOPERATIVE',

    selectedOwner: {
      id: '',
      name: '',
    },

    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    // talhoesSelecionados: [],
  });

  const [currentPage, setCurrentPage] = useState(-1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const locationObject = useLocation();
  const [serviceRequestParameters, setServiceRequestParameters] = useState(initialParameters());

  useEffect(() => {
    if (!locationObject.state?.serviceRequestParams) {
      notification.error({
        description: 'Houve um erro ao solicitar o serviço.',
      });
      navigate('/service/new');
      return;
    }

    setServiceRequestParameters(locationObject.state?.serviceRequestParams);
    setCurrentPage(0);
  }, []);

  const previousPage = (parameters) => {
    if (currentPage === 0) {
      navigate('/service/new', {
        state: {
          skipToPage: 2,
          serviceID: serviceRequestParameters.selectedService.id,
          matriculation: serviceRequestParameters.matriculation,
          allServiceParameters: serviceRequestParameters,
        },
      });
      return;
    }

    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous - 1);
  };

  const nextPage = (parameters) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous + 1);
  };

  return (
    <div className="MontagemEquipamentoFlow">
      <Spin tip="Carregando..." spinning={loading}>
        <Row>
          <Col span={24}>
            <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
              {
                currentPage === 0
                && (
                  <MontagemEquipamentoDetails
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 1 ? 'block' : 'none' }}>
              {
                currentPage === 1
                && (
                  <MontagemEquipamentoSummary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 2 ? 'block' : 'none' }}>
              <SuccessSolicitation
                previousPage={previousPage}
                params={serviceRequestParameters}
              />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

MontagemEquipamentoFlow.propTypes = {};
MontagemEquipamentoFlow.defaultProps = {};

export default MontagemEquipamentoFlow;
